import { round, upperFirst } from "lodash";
import moment from "moment";
import {
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Bar,
  ComposedChart,
  Tooltip,
  ReferenceLine,
  Line,
} from "recharts";
import { bodyWeightFormat } from "../body-composition.helper";
import NoData from "./NoData";

const mapData = (data, targetValue) => ({
  date: data.utcDate,
  value: data[targetValue],
});
//sort utcDate from less to high value
const sortData = (a, b) => a.utcDate - b.utcDate;

const BarGraph = ({
  data,
  targetValue,
  average,
  graphId,
  parseFn = (val) => val,
  type = "Bar",
  units = "",
  noTooltip = false,
}) => {
  const toSort = data.map((x) => x);
  const chartData = toSort
    .sort(sortData)
    .filter((data) => data[targetValue] > 0)
    .map((data) => mapData(data, targetValue));

  if (!chartData.length) {
    return <NoData />;
  }

  const ticks = [chartData[0].date, chartData[chartData.length - 1 || 0].date];

  return (
    <ResponsiveContainer width="99%" height="100%" id={graphId}>
      <ComposedChart data={chartData}>
        <CartesianGrid
          stroke="var(--grid-chart-line)"
          strokeDasharray="5 5"
          strokeWidth={1}
          horizontal={true}
          vertical={false}
        />
        <XAxis
          dataKey="date"
          ticks={ticks}
          tickFormatter={(utcDate) =>
            moment(utcDate, "YYYYMMDD").format("MMM D, YYYY")
          }
          scale="dot"
          interval={"preserveStartEnd"}
          fontSize={"12"}
          // offset={"12"}
          tick={{ fill: "var(--white)" }}
          dy={5}
          hide={noTooltip}
        />
        <YAxis tick={null} hide={true} />
        {!noTooltip && (
          <Tooltip
            content={
              <CustomTooltip
                customLabel={targetValue}
                description={targetValue}
                units={units}
                parseFn={parseFn}
              />
            }
          />
        )}
        {type === "Bar" ? (
          <Bar dataKey="value" barSize={20} fill="#00afe4" />
        ) : (
          <Line
            dataKey="value"
            type="linear"
            stroke="rgba(91, 197, 0, 1)"
            fill="var(--primary)"
          />
        )}
        {!noTooltip && (
          <ReferenceLine
            stroke="var(--white)"
            strokeDasharray="5 5"
            strokeWidth={1}
            y={average}
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

// To show the tooltip with a different style and information
const CustomTooltip = ({
  active,
  payload,
  customLabel,
  description,
  units,
  parseFn,
}) => {
  // the condition for the length of the payload is for the first point of the line
  // as that one only has a target of 0, making the lenth 1

  if (active && payload && payload.length > 0 && payload[0].name !== "avg") {
    //   // The payload is an array of objects, the structure would always be like this,
    //   // As the time of writing, there are not more than one value displayed
    //   // [
    //   //   {name: "value", value: 0, payload: { date: 'Aug 13, 2021' }, ...}
    //   // ]
    //

    return (
      <div className="custom-tooltip">
        <span className="label">
          {upperFirst(customLabel)} (
          {moment(String(payload[0].payload.date)).format(bodyWeightFormat)})
        </span>
        <span className="value">
          {upperFirst(description)}: {parseFn(round(payload[0].value, 0))}{" "}
          {units}
        </span>
      </div>
    );
  }

  return null;
};

export default BarGraph;
